"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsSingle = void 0;
var react_1 = __importStar(require("react"));
var OptionsShell_1 = require("../OptionsShell");
var useKeyboardControl_1 = require("../../utils/useKeyboardControl");
var useSetYOrientation_1 = require("../../utils/useSetYOrientation");
var List_1 = require("../../../List");
var getValue_1 = require("../../utils/getValue");
/**
 * if used independently, must be used inside a 'position: relative/absolute' div.
 */
var OptionsSingle = function (_a) {
    var 
    //from root
    lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, optionsAnchor = _a.optionsAnchor, value = _a.value, id = _a.id, optionsClassName = _a.optionsClassName, 
    //from Dropdown
    relativeToRef = _a.relativeToRef, //the element that this lightbox is being rendered against. i.e top or bottom
    showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, handleSelect = _a.handleSelect, options = _a.options, isSearchable = _a.isSearchable, label = _a.label, optionsModalLabel = _a.optionsModalLabel, //label is just a fallback for optionsModalLabel. Don't know why both are needed
    searchString = _a.searchString, setSearchString = _a.setSearchString, SelectComp = _a.SelectComp, genCreateTagButton = _a.genCreateTagButton, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, _b = _a.enableUseSetYOrientation, enableUseSetYOrientation = _b === void 0 ? true : _b, // if using this component standalone, this should be set to false ( if relativeToRef is not being passed thru)
    S = _a.S, observerRef = _a.observerRef, _c = _a.searchbarPlaceholder, searchbarPlaceholder = _c === void 0 ? "Search" : _c, alignDropdown = _a.alignDropdown, matchSelectInputWidth = _a.matchSelectInputWidth;
    //INIT ORIENTATION STATE AND CUSTOM HOOK
    var optionsRef = (0, react_1.useRef)(null);
    var yOrientation = (0, useSetYOrientation_1.useSetYOrientation)({
        showOptions: showOptions,
        optionsRef: optionsRef,
        relativeToRef: relativeToRef,
        enabled: enableUseSetYOrientation,
    }).yOrientation;
    var _d = (0, useKeyboardControl_1.useKeyboardControl)({
        showOptions: showOptions,
        optionsWrapperRef: optionsRef,
        handleHideOptions: handleHideOptions,
        handleSelect: handleSelect,
        options: options,
        searchString: searchString,
        id: id,
    }), scrollFocussedOpIntoView = _d.scrollFocussedOpIntoView, focussedOp = _d.focussedOp;
    var _e = (0, react_1.useState)(true), searchBarFocus = _e[0], setSearchBarFocus = _e[1];
    (0, react_1.useEffect)(function () {
        setSearchBarFocus(showOptions);
    }, [showOptions]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OptionsShell_1.OptionsShell, { ref: optionsRef, yOrientation: yOrientation, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, options: options, optionsAnchor: optionsAnchor, showOptions: showOptions, SelectComp: SelectComp, handleHideOptions: handleHideOptions, label: label, optionsModalLabel: optionsModalLabel, relativeToRef: relativeToRef, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, alignDropdown: alignDropdown, matchSelectInputWidth: matchSelectInputWidth, S: S },
            react_1.default.createElement(List_1.List, { options: options, value: value, focussedOp: focussedOp, scrollFocussedOpIntoView: scrollFocussedOpIntoView, handleSelect: handleSelect, optionsClassName: optionsClassName, S: S, observerRef: observerRef, grouped: (0, getValue_1.isGroupedData)(options), isSearchable: isSearchable, searchbarPlaceholder: searchbarPlaceholder, searchBarFocus: searchBarFocus, searchString: searchString, setSearchString: setSearchString, setSearchBarFocus: setSearchBarFocus }),
            genCreateTagButton && genCreateTagButton(options))));
};
exports.OptionsSingle = OptionsSingle;
